import React from 'react';
import step1 from '../../assests/images/step-1.png';
import step2 from '../../assests/images/step-2.png';
import step3 from '../../assests/images/step-3.png';
import arrowRight from '../../assests/images/arrow-right.png'
import { Link } from 'react-router-dom';

const Process = () => {
    return (
        <div>
            <div className='container py-5'>
                <div className='row'>
                    <div className='col-lg-12 text-center mb-4'>
                        <p className="red-clr f-16 lh-1 mt-5 f-pop-med">How to Hire Us?</p>
                        <p className="blu-clr-book f-47 lh-1 mb-2 f-pop-med">Follow Our 1-Minute Hiring Process</p>
                    </div>
                    <div className='col-lg-4'>
                        <div className='d-flex res-tabl'>
                            <img src={step1} className="res-img-process h-100px" alt="step-1" />
                            <div className='ms-3'>
                                <p className='f-16 mb-2 f-pop-med'>Fill form for Private Taxi Hire</p>
                                <p className='f-12 lh-2 f-pop-reg'>Enter your name, email address, home address, and contact number.</p>
                            </div>
                            <img src={arrowRight} className='arr-process ms-3' alt="p-1" />
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='d-flex res-tabl'>
                            <img src={step2} className="res-img-process h-100px" alt="s-2" />
                            <div className='ms-3'>
                                <p className='f-16 mb-2 f-pop-med'>Contact our Taxi 24x7</p>
                                <p className='f-12 lh-2  f-pop-reg'>We will reach out to you with Stansted Taxi Quote after understanding your travelling needs.</p>
                            </div>
                            <img src={arrowRight} className='arr-process ms-3' alt="p-1" />
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='d-flex res-tabl'>
                            <img src={step3} className="res-img-process h-100px" alt="s-3" />
                            <div className='ms-3'>
                                <p className='f-16 mb-2  f-pop-med'>Booking Confirmed</p>
                                <p className='f-12 lh-2  f-pop-reg'>You will receive a confirmation message from our reliable airport transfer services within the first few minutes of contact. </p>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-12 text-center mt-5'>
                        <Link to="/contactus">
                            <button className='btn btn-danger red-clr-btn p-bt-cus contact-des f-pop-med f-14'>Contact us</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Process;